import { z } from 'zod';
import { isoDateTimeSchema } from './common.js';
/**
 * Shared wire schemas for `GET /health/workers` — Wave 2.46 BE-1
 * (TASK-013b-followup-worker-health).
 *
 * Worker liveness probe backed by `internal.worker_heartbeats`. Each worker
 * UPSERTs a row every 30 seconds; the probe labels every row by the age of
 * its `last_heartbeat_at`:
 *
 *   * `<60s`   ⇒ `healthy`
 *   * `60–300s` ⇒ `stale`
 *   * `>300s`  ⇒ `down`
 *
 * Overall:
 *   * any row labelled `down` (or no rows at all) ⇒ `down`
 *   * else any row labelled `stale` ⇒ `degraded`
 *   * else ⇒ `healthy`
 *
 * The endpoint is `@SuperAdminOnly()` to avoid leaking worker topology
 * (hostname, pid, version) to unauthenticated callers.
 */
export const workerHealthStatusSchema = z.enum(['healthy', 'stale', 'down']);
export const workerHealthOverallSchema = z.enum([
    'healthy',
    'degraded',
    'down',
]);
export const workerHealthRowSchema = z
    .object({
    worker_id: z.string().min(1),
    last_heartbeat_at: isoDateTimeSchema,
    age_seconds: z.number().int().min(0),
    status: workerHealthStatusSchema,
    hostname: z.string().nullable(),
    pid: z.number().int().nullable(),
    version: z.string().nullable(),
})
    .strict();
export const workerHealthResponseSchema = z
    .object({
    workers: z.array(workerHealthRowSchema),
    overall: workerHealthOverallSchema,
})
    .strict();
/**
 * Thresholds in seconds — exported so BE service and any FE consumer share
 * the same boundary values.
 */
export const WORKER_HEALTH_HEALTHY_MAX_AGE_SECONDS = 60;
export const WORKER_HEALTH_STALE_MAX_AGE_SECONDS = 300;
//# sourceMappingURL=worker-health.js.map